<template>
  <div class="page-container">
    <img src="../assets/img/502.png" alt style="width:80%" />
    <p >抱歉，您没有访问权限【502】</p>
  </div>
</template>

<script>
export default {
  name: "page502",
  mounted() {
  }
};
</script>

<style scoped>
.page-container {
  font-size: 20px;
  text-align: center;
  color: rgb(192, 204, 218);
  background: #ffffff;
  min-height: 100vh;
  padding-top: 10vh;
}
</style>